import React, { useContext, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";

import TicketsManager from "../../components/TicketsManagerTabs/";
import Ticket from "../../components/Ticket/";
import { AuthContext } from "../../context/Auth/AuthContext";
import { socketConnection } from "../../services/socket";

import { i18n } from "../../translate/i18n";
import { Hidden } from "@material-ui/core";
import MainContainer from '../../components/MainContainer';

const useStyles = makeStyles(theme => ({
	chatContainer:{
		padding: "78px 5px 5px 5px",
		height: `100vh`,
		overflow:"hidden"
	},
	chatPapper: {
		display: "flex",
		height: "100%",
	},

	contactsWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
		overflowY: "hidden",
	},
	messagesWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
	},
	welcomeMsg: {
		background: theme.palette.type === "dark"
			? "linear-gradient(135deg, rgba(53, 175, 154, 0.05) 0%, rgba(30, 41, 59, 0.8) 100%)"
			: "linear-gradient(135deg, rgba(53, 175, 154, 0.03) 0%, #F8FAFC 100%)",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		height: "100%",
		textAlign: "center",
		gap: 16,
		border: "none",
	},
	welcomeIcon: {
		fontSize: 56,
		color: theme.palette.type === "dark" ? "rgba(53, 175, 154, 0.3)" : "rgba(53, 175, 154, 0.25)",
	},
	welcomeText: {
		fontFamily: '"Inter", "Poppins", sans-serif',
		fontSize: 16,
		fontWeight: 500,
		color: theme.palette.type === "dark" ? "#94A3B8" : "#94A3B8",
		letterSpacing: "-0.01em",
	},
	welcomeSubText: {
		fontFamily: '"Inter", "Poppins", sans-serif',
		fontSize: 13,
		color: theme.palette.type === "dark" ? "#64748B" : "#CBD5E1",
	},
}));

const TicketsCustom = () => {
	const classes = useStyles();
	const { ticketId } = useParams();

	return (
		<MainContainer>
				<div className={classes.chatPapper}>
					<Grid container spacing={0}>
						<Grid item xs={12} md={4} className={classes.contactsWrapper}>
							<TicketsManager />
						</Grid>
						<Grid item xs={12} md={8} className={classes.messagesWrapper}>
							{ticketId ? (
								<>
									<Ticket
									/>
								</>
							) : (
								<Hidden only={["sm", "xs"]}>
									<Paper square variant="outlined" className={classes.welcomeMsg}>
										<ChatBubbleOutlineIcon className={classes.welcomeIcon} />
										<Typography className={classes.welcomeText}>
											{i18n.t("chat.noTicketMessage")}
										</Typography>
										<Typography className={classes.welcomeSubText}>
											Selecione uma conversa ao lado para começar
										</Typography>
									</Paper>
								</Hidden>
							)}
						</Grid>
					</Grid>
				</div>
		</MainContainer>
	);
};

export default TicketsCustom;
